import { CommonModule } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnDestroy } from '@angular/core';
import { NavService } from './boton-listado.component.service';
import { UserService } from '../_services/user.service';
import { UnsubscribeOnDestroy } from '../_helpers/unsubscribe-on-destroy';
 
@Component({
  selector: 'boton-listado',
  templateUrl: './boton-listado.component.html',
  standalone: true,
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],  
  styleUrls: ['./boton-listado.component.css'],
  imports: [CommonModule]
})

export class BotonListado extends UnsubscribeOnDestroy  {

  opcionesListado: any = this.inicializar();
  desplegableVisible: boolean = false;
  classBoton: string = 'btn btn-primary mt-2 dropdown-toggle dropdown-toggle-split';
  disabled: boolean = false;
    selectedOpcion : String = this.opcionesListado && this.opcionesListado.length > 0? this.opcionesListado[0]:"";
    constructor(private _navService:NavService,private userService: UserService, private elementRef: ElementRef) {
      super();
    }
    selectedNavItem() {
      this._navService.changeNav(this.selectedOpcion);
    }
    onSelect(opcion: String): void {
        this.selectedOpcion = opcion;
        this.selectedNavItem();
        const listado = this.elementRef.nativeElement.querySelector('#listado-split');
        if(listado?.classList.contains("show")){
          listado.classList.remove("show");
        }
    }
    despliegaOpciones(){
      const listado = this.elementRef.nativeElement.querySelector('#listado-split');
      if(listado?.classList.contains("show")){
        listado.classList.remove("show");
      }
      else{
        listado?.classList.add("show");
      }
    }
    init( opt : any ) { 
      this.opcionesListado = opt;
      this.selectedOpcion = this.opcionesListado.length > 0? this.opcionesListado[0]:"";
      this.classBoton =  this.opcionesListado.length > 1?'btn btn-primary mt-2':'btn btn-primary mt-2 border-button';
      this.desplegableVisible = this.opcionesListado && this.opcionesListado.length > 1? true:false;
      // Sincroniza con el padre (notificaciones-usuario) en cuanto hay tipofirma.
      this.selectedNavItem();
    }
    inicializar( ) { 
      this.userService.getCurrentTipoFirmaFromServer()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
        next: (data:any) => {
          this.init(data.tipofirma );
          return data.tipofirma;          
        },
        error: (error) => {}
      })      
      
    }

    
}
